// src/components/Profile/ProfileDetails.jsx
import React, { useEffect, useState } from "react";
import ProfileInfoSkeleton from "./ProfileInfoSkeleton";
import PasswordChangeModal from "./PasswordChangeModal";
import { fetchUserData } from "../../utilities/UserProfileUtilities";


function ProfileDetails() {
  const [userProfile, setUserProfile] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    secondary_contacts: "",
    organization: "",
    role: "",
  });

  const [editable, setEditable] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const handlePasswordModalClose = () => setShowPasswordModal(false);
  const handlePasswordModalShow = () => setShowPasswordModal(true);

  useEffect(() => {
    fetchUserData(setLoading, setUserProfile);
  }, []);

  const saveProfile = () => {
    setLoading(true);
    // TODO: Add save profile functionality
    console.log("Save profile functionality here.");
    setLoading(false);
    setEditable(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserProfile((prev) => ({
      ...prev,
      [name]: value ?? "",
    }));
  };

  const valOrEmpty = (v) => (v == null ? "" : String(v));
  const valOrNA = (v) => (v == null || String(v).trim() === "" ? "N.A." : String(v));

  const fields = [
    { name: "first_name", label: "First name", editable: true },
    { name: "last_name", label: "Last name", editable: true },
    { name: "email", label: "Email address", type: "email" },
    { name: "phone_number", label: "Phone number", type: "tel", editable: true },
    { name: "secondary_contacts", label: "Secondary contact", type: "tel", editable: true },
    { name: "organization", label: "Organization" },
    { name: "role", label: "Role" },
  ];

  const fullName = [userProfile.first_name, userProfile.last_name]
    .filter((part) => part && String(part).trim())
    .join(" ");
  const initials =
    [userProfile.first_name, userProfile.last_name]
      .map((part) => String(part || "").trim().charAt(0).toUpperCase())
      .join("") || "?";

  return (
    <>
      {loading ? (
        <ProfileInfoSkeleton />
      ) : (
        <section className="ea-card">
          <div className="ea-identity">
            <div className="ea-avatar" aria-hidden="true">{initials}</div>
            <div className="flex-grow-1">
              <strong>{fullName || valOrNA(userProfile.email)}</strong>
              <span>{[userProfile.role, userProfile.organization].filter(Boolean).join(" · ")}</span>
            </div>
            <button type="button" className="ea-btn" onClick={() => setEditable((p) => !p)}>
              {editable ? "Cancel" : "Edit"}
            </button>
          </div>

          <div className="ea-card-body ea-grid">
            {fields.map((field) => {
              const value = userProfile[field.name];
              const isEditing = editable && field.editable;
              const isEmpty = value == null || String(value).trim() === "";
              return (
                <div key={field.name} className="ea-field">
                  <label htmlFor={`profile-${field.name}`}>{field.label}</label>
                  {isEditing ? (
                    <input
                      id={`profile-${field.name}`}
                      type={field.type || "text"}
                      name={field.name}
                      value={valOrEmpty(value)}
                      onChange={handleInputChange}
                    />
                  ) : (
                    <div className={`ea-value${isEmpty ? " is-empty" : ""}`}>{valOrNA(value)}</div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="ea-card-foot">
            <button type="button" className="ea-btn" onClick={handlePasswordModalShow}>
              Change password
            </button>
            {editable && (
              <button type="button" className="ea-btn is-primary" onClick={saveProfile}>
                Save changes
              </button>
            )}
          </div>
        </section>
      )}

      <PasswordChangeModal show={showPasswordModal} handleClose={handlePasswordModalClose} />
    </>
  );
}

export default ProfileDetails;
